"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var ProgressBar_1 = __importDefault(require("atomicComponents/atoms/ProgressBar/ProgressBar"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
exports.default = (0, styles_1.styled)((0, DefaultPropsHoC_1.default)(ProgressBar_1.default, { value: 100 }), { shouldForwardProp: (0, general_1.omitProps)('value') })(function (_a) {
    var _b;
    var _c, _d, _e;
    var theme = _a.theme, value = _a.value;
    return (_b = {
            height: theme.spacing(1),
            borderRadius: theme.spacing(1)
        },
        _b["&.".concat(material_1.linearProgressClasses.colorPrimary)] = {
            backgroundColor: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.light,
        },
        _b[".".concat(material_1.linearProgressClasses.bar)] = {
            width: "".concat(value, "%"),
            borderRadius: theme.spacing(1),
            backgroundColor: (_d = theme.palette.neutral) === null || _d === void 0 ? void 0 : _d.light,
            backgroundImage: theme.blend.inverted500,
            borderColor: (_e = theme.palette.neutral) === null || _e === void 0 ? void 0 : _e.light,
        },
        _b);
});
